import React, { useEffect, useState } from 'react';
import { dispatchService } from '../../../services/central-api/dispatch';
import FilterCheckboxList, { FilterListItem } from './FilterCheckboxList';

interface Props {
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
}

export default function DispatchDisplacedReasonsList({ value, setValue }: Props) {
    const [items, setItems] = useState<FilterListItem[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    async function getDisplaceReasons() {
        try {
            setIsLoading(true);
            const displacedReasons = await dispatchService.getDisplaceReasons();
            setItems(displacedReasons.map((item) => ({ label: item.name, value: item.id })));
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getDisplaceReasons();
    }, []);

    return <FilterCheckboxList items={items} value={value} setValue={setValue} isLoading={isLoading} />;
}
